export interface RecordedKey {
	altKey: boolean;
	code: string;
	ctrlKey: boolean;
	key: string;
	metaKey: boolean;
	shiftKey: boolean;
}

export const MAX_CHORD_STEPS = 2;

const MODIFIER_EVENT_KEYS = new Set(["Alt", "AltGraph", "Control", "Meta", "OS", "Shift"]);

const isPrintableAscii = (value: string): boolean => value.length === 1 && value >= " " && value <= "~";

export const recordedKeyFromEvent = (event: KeyboardEvent): RecordedKey => ({
	altKey: event.altKey,
	code: event.code,
	ctrlKey: event.ctrlKey,
	key: event.key,
	metaKey: event.metaKey,
	shiftKey: event.shiftKey
});

export const isModifierKey = (recorded: RecordedKey): boolean => MODIFIER_EVENT_KEYS.has(recorded.key);

export const hasComboModifier = (recorded: RecordedKey): boolean =>
	recorded.ctrlKey || recorded.metaKey || recorded.altKey;

const normalizeRecordedKeyToken = (key: string): string => {
	if (key === " " || key === "Spacebar") return "space";
	return key.toLowerCase();
};

export const serializeRecordedKey = (recorded: RecordedKey): string => {
	const modifiers: string[] = [];
	if (recorded.ctrlKey || recorded.metaKey) modifiers.push("mod");
	if (recorded.altKey) modifiers.push("alt");
	if (recorded.shiftKey) modifiers.push("shift");
	return [...modifiers, normalizeRecordedKeyToken(recorded.key)].join("+");
};

export const serializeRecording = (keys: RecordedKey[]): string => keys.map(serializeRecordedKey).join(" ");

export const hasMacAltGlyphIssue = (recorded: RecordedKey, isMac: boolean): boolean => {
	if (!isMac || !recorded.altKey) return false;
	if (recorded.key.length !== 1) return false;
	return !isPrintableAscii(recorded.key);
};
